import PropTypes from 'prop-types';
import React from 'react';
import GenericFormItem from '../GenericFormItem';

const TextAreaField = function TextAreaField(props) {
  const {
    val,
    label,
  } = props;
  return (
    <GenericFormItem label={label}>
      <div className="text-area-field-value">{val}</div>
    </GenericFormItem>
  );
};

TextAreaField.propTypes = {
  val: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/TextAreaField.js